import { PayloadAction } from '@reduxjs/toolkit';
import { delay, put, takeLatest } from 'redux-saga/effects';
import { close, open, trigger } from 'redux/slice/ui/ErrorModal.slice';

function* handleErrorModalTrigger(
  action: PayloadAction<{ message: string; subMessage?: string }>
) {
  // Ensure modal can re-open even if already open
  yield put(close());
  // Small tick to let state update propagate
  yield delay(0);
  yield put(
    open({
      message: action.payload.message,
      subMessage: action.payload.subMessage,
    })
  );
}

export function* watchErrorModalSaga() {
  yield takeLatest(trigger.type, handleErrorModalTrigger);
}
